// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1lmZx","Logo":"Toolbar_Logo__26BOu","DesktopOnly":"Toolbar_DesktopOnly__Kr0C0"};